import React, { Component } from "react";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock
} from "react-bootstrap";

class SMSTextField extends Component {
  constructor() {
    super();

    this.state = {
      value: "",
      count: 0,
      disabled: false,
      touched: false
    };

    this.getValidationState = this.getValidationState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.isValid = this.isValid.bind(this);
  }
  handleChange(e) {
    const { onUpdate } = this.props;
    let value = e.target.value;
    this.setState({ value, count: value.length, touched: true }, () => {
      let SMSTextObject = {
        isValid: this.isValid(),
        text: value
      };
      onUpdate(SMSTextObject);
    });
  }
  isValid() {
    const value = this.state.value;
    const length = value.length;
    if (length > 135) return false;
    else if (length === 0) return false;
    else if (!/\*\|URL\|\*/g.test(value)) return false;
    else if (/\*\|URL\|\*/.test(value)) return true;
  }
  getValidationState() {
    let { touched } = this.state;
    if (!touched) {
      return null;
    } else if (this.isValid()) {
      return "success";
    } else {
      return "error";
    }
  }
  render() {
    let { count } = this.state;
    return (
      <FormGroup
        controlId="formBasicText"
        validationState={this.getValidationState()}
      >
        <ControlLabel>Digite o texto desejado.</ControlLabel>
        <FormControl
          componentClass="textarea"
          value={this.state.value}
          placeholder="Digite o SMS desejado"
          onChange={this.handleChange}
        />
        <FormControl.Feedback />
        <HelpBlock>
          Contador: {count}. Verifique se a tag *|URL|* está sendo utilizada
        </HelpBlock>
      </FormGroup>
    );
  }
}

export default SMSTextField;



// WEBPACK FOOTER //
// ./src/components/SMSTextField.js